import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';

import CheckBoxWidget from './CheckBoxWidget';
import CheckBoxWithTextFieldWidget from './CheckBoxWithTextFieldWidget';
import DatePickerWidget from './DatePickerWidget';
import DateTimePickerWidget from './DateTimePickerWidget';
import DecimalFieldWidget from './DecimalFieldWidget';
import IntegerFieldWidget from './IntegerFieldWidget';
import PatientAssetWidget from './patient_asset_widget/PatientAssetWidget';
import RadioButtonWidget from './RadioButtonWidget';
import RadioButtonWithTextFieldWidget from './RadioButtonWithTextFieldWidget';
import TextAreaWidget from './TextAreaWidget';
import TextFieldWidget from './TextFieldWidget';

const widgetComponentMap: Record<
	string,
	React.FC<IQuestionnaireFormWidgetProps>
> = {
	text_field: TextFieldWidget,
	text_area: TextAreaWidget,

	integer_field: IntegerFieldWidget,
	decimal_field: DecimalFieldWidget,

	date_picker: DatePickerWidget,
	datetime_picker: DateTimePickerWidget,

	radio_button: RadioButtonWidget,
	radiobutton_with_text_field: RadioButtonWithTextFieldWidget,

	check_box: CheckBoxWidget,
	check_box_with_text_field: CheckBoxWithTextFieldWidget,

	file_field: PatientAssetWidget,
};

export default widgetComponentMap;
